{
  "labels": {
    "signUp": "",
    "signIn": "",
    "paste": "ထား",
    "pasteAsPlaintext": "",
    "pasteCharts": "",
    "chartType_bar": "",
    "chartType_line": "",
    "chartType_radar": "",
    "chartType_plaintext": "",
    "selectAll": "အကုန်ရွေး",
    "multiSelect": "ရွေးထားသည့်ထဲပုံထည့်",
    "moveCanvas": "ကားချပ်ရွှေ့",
    "cut": "",
    "copy": "ကူး",
    "copyAsPng": "PNG အနေဖြင့်ကူး",
    "copyAsSvg": "SVG အနေဖြင့်ကူး",
    "copyText": "",
    "copySource": "",
    "convertToCode": "",
    "bringForward": "ရှေ့ပို့",
    "sendToBack": "နောက်ဆုံးထား",
    "bringToFront": "ရှေ့ဆုံးထား",
    "sendBackward": "နောက်ပို့",
    "delete": "ဖျက်",
    "copyStyles": "ပုံစံကူး",
    "pasteStyles": "ပုံစံထား",
    "stroke": "မျဉ်း",
    "changeStroke": "",
    "background": "နောက်ခံ",
    "changeBackground": "",
    "fill": "ဖြည့်",
    "strokeWidth": "မျဉ်းအထူ",
    "strokeStyle": "မျဉ်းပုံစံ",
    "strokeStyle_solid": "အပြည့်",
    "strokeStyle_dashed": "မျဉ်းပြတ်",
    "strokeStyle_dotted": "မျဉ်းစက်",
    "sloppiness": "သေသပ်မှု",
    "pressure": "",
    "pressure_constant": "",
    "pressure_variable": "",
    "opacity": "ထင်ရှားမှု",
    "textAlign": "စာသားညှိ",
    "edges": "အစွန်း",
    "sharp": "ထောင့်ချွန်",
    "round": "ထောင့်ဝိုင်း",
    "arrowheads": "မြှားခေါင်း",
    "arrowhead_none": "ဘာမျှမရှိ",
    "arrowhead_arrow": "မြှား",
    "arrowhead_bar": "",
    "arrowhead_circle": "",
    "arrowhead_circle_outline": "",
    "arrowhead_triangle": "",
    "arrowhead_triangle_outline": "",
    "arrowhead_diamond": "",
    "arrowhead_diamond_outline": "",
    "arrowhead_crowfoot_many": "",
    "arrowhead_crowfoot_one": "",
    "arrowhead_crowfoot_one_or_many": "",
    "arrowhead_cardinality_one": "",
    "arrowhead_cardinality_many": "",
    "arrowhead_cardinality_one_or_many": "",
    "arrowhead_cardinality_exactly_one": "",
    "arrowhead_cardinality_zero_or_one": "",
    "arrowhead_cardinality_zero_or_many": "",
    "more_options": "",
    "cardinality": "",
    "arrowtypes": "",
    "arrowtype_sharp": "",
    "arrowtype_round": "",
    "arrowtype_elbowed": "",
    "fontSize": "စာလုံးအရွယ်",
    "fontFamily": "စာလုံးပုံစံ",
    "addWatermark": "\"Excalidraw ဖြင့်ဖန်တီးသည်။\" စာသားထည့်",
    "handDrawn": "လက်ရေး",
    "normal": "ပုံမှန်",
    "code": "ကုဒ်",
    "small": "အသေး",
    "medium": "အလတ်",
    "large": "အကြီး",
    "veryLarge": "ပိုကြီး",
    "solid": "အပြည့်",
    "hachure": "မျဉ်းစောင်း",
    "zigzag": "",
    "crossHatch": "ဇကာကွက်",
    "thin": "ပါး",
    "bold": "ထူ",
    "left": "ဘယ်",
    "center": "အလယ်",
    "right": "ညာ",
    "extraBold": "ပိုထူ",
    "architect": "ဗိသုကာ",
    "artist": "ပန်းချီ",
    "cartoonist": "ကာတွန်း",
    "fileTitle": "",
    "colorPicker": "အရောင်ရွေး",
    "canvasColors": "",
    "canvasBackground": "ကားချပ်နောက်ခံ",
    "drawingCanvas": "ပုံဆွဲကားချပ်",
    "clearCanvas": "",
    "layers": "အလွှာများ",
    "actions": "လုပ်ဆောင်ချက်များ",
    "language": "ဘာသာစကား",
    "liveCollaboration": "",
    "duplicateSelection": "ပွား",
    "untitled": "အမည်မရှိ",
    "name": "အမည်",
    "yourName": "သင့်အမည်",
    "madeWithExcalidraw": "Excalidraw ဖြင့်ဖန်တီးသည်။",
    "group": "အုပ်စုဖွဲ့",
    "ungroup": "အုပ်စုဖျက်သိမ်း",
    "collaborators": "ပူးပေါင်းပါဝင်သူများ",
    "you": "",
    "toggleGrid": "",
    "loadingScene": "မြင်ကွင်းဖော်နေသည်…",
    "loadScene": "",
    "align": "ချိန်ညှိ",
    "alignTop": "ထိပ်ညှိ",
    "alignBottom": "အခြေညှိ",
    "alignLeft": "ဘယ်ညှိ",
    "alignRight": "ညာညှိ",
    "centerVertically": "ဒေါင်လိုက်အလယ်ညှိ",
    "centerHorizontally": "အလျားလိုက်အလယ်ညှိ",
    "distributeHorizontally": "အလျားလိုက်",
    "distributeVertically": "ထောင်လိုက်",
    "flipHorizontal": "",
    "flipVertical": "",
    "viewMode": "",
    "share": "",
    "showStroke": "",
    "showBackground": "",
    "showFonts": "",
    "toggleTheme": "",
    "theme": "",
    "decreaseFontSize": "",
    "increaseFontSize": "",
    "unbindText": "",
    "bindText": "",
    "createContainerFromText": "",
    "link": {
      "edit": "",
      "editEmbed": "",
      "create": "",
      "label": "",
      "labelEmbed": "",
      "empty": "",
      "hint": "",
      "goToElement": ""
    },
    "lineEditor": {
      "edit": "",
      "editArrow": ""
    },
    "polygon": {
      "breakPolygon": "",
      "convertToPolygon": ""
    },
    "elementLock": {
      "lock": "",
      "unlock": "",
      "lockAll": "",
      "unlockAll": ""
    },
    "sidebarLock": "",
    "selectAllElementsInFrame": "",
    "removeAllElementsFromFrame": "",
    "eyeDropper": "",
    "followUs": "",
    "discordChat": "",
    "zoomToFitViewport": "",
    "zoomToFitSelection": "",
    "zoomToFit": "",
    "installPWA": "",
    "autoResize": "",
    "imageCropping": "",
    "unCroppedDimension": "",
    "copyElementLink": "",
    "linkToElement": "",
    "wrapSelectionInFrame": "",
    "tab": "",
    "shapeSwitch": "",
    "preferences": "",
    "preferences_toolLock": "",
    "boxSelectionMode": "",
    "boxSelectionContain": "",
    "boxSelectionOverlap": "",
    "arrowBinding": "",
    "midpointSnapping": ""
  },
  "elementLink": {
    "title": "",
    "desc": "",
    "notFound": ""
  },
  "search": {
    "title": "",
    "noMatch": "",
    "singleResult": "",
    "multipleResults": "",
    "placeholder": "",
    "frames": "",
    "texts": ""
  },
  "buttons": {
    "clearReset": "ကားချပ်ရှင်းလင်း",
    "exportJSON": "",
    "exportImage": "",
    "export": "",
    "copyToClipboard": "ကူးယူ",
    "copyLink": "",
    "save": "",
    "saveAs": "ပြောင်းသိမ်း",
    "load": "",
    "getShareableLink": "မျှဝေရန် လင့်ခ်ရယူ",
    "close": "ပိတ်",
    "selectLanguage": "ဘာသာစကားရွေးပါ",
    "scrollBackToContent": "ကားချပ်ပြန်တည်",
    "zoomIn": "ချဲ့",
    "zoomOut": "ချုံ့",
    "resetZoom": "ပုံမှန်ပြန်ထား",
    "menu": "မီနူး",
    "done": "ပြီးပြီ",
    "edit": "ပြင်ဆင်",
    "undo": "ပြန်ထား",
    "redo": "ထပ်လုပ်",
    "createNewRoom": "အခန်းသစ်ဖွဲ့",
    "fullScreen": "",
    "darkMode": "",
    "lightMode": "",
    "systemMode": "",
    "zenMode": "",
    "objectsSnapMode": "",
    "exitZenMode": "ဇင်မြင်ကွင်းမှထွက်",
    "cancel": "",
    "clear": "",
    "remove": "",
    "embed": "",
    "submit": "",
    "confirm": "",
    "embeddableInteractionButton": ""
  },
  "alerts": {
    "clearReset": "ကားချပ်တစ်ခုလုံးရှင်းလင်းပါတော့မည်။ အတည်ပြုပါ။",
    "couldNotCreateShareableLink": "မျှဝေရန် လင့်ခ်မရယူနိုင်သေးပါ။",
    "couldNotCreateShareableLinkTooBig": "မြင်ကွင်းအရမ်းကြီးနေသဖြင့် မျှဝေရန် လင့်ခ်မရယူနိုင်သေးပါ။",
    "couldNotLoadInvalidFile": "လွဲမှားနေသောဖိုင်အား တင်၍မရပါ။",
    "importBackendFailed": "Backend မှမလုပ်ဆောင်နိုင်သေးပါ။",
    "cannotExportEmptyCanvas": "ကားချပ်အလွတ်အားထုတ်ယူ၍မရပါ။",
    "couldNotCopyToClipboard": "",
    "decryptFailed": "အချက်အလက်ဖော်ယူ၍မရပါ။",
    "uploadedSecurly": "တင်သွင်းအချက်အလက်များအား နှစ်ဘက်စွန်းတိုင်လျှို့ဝှက်စနစ်အသုံးပြု၍လုံခြုံစွာထိန်းသိမ်းထားပါသဖြင့် Excalidraw ဆာဗာနှင့်ဆက်စပ်အဖွဲ့အစည်းများပင်လျှင်မဖတ်ရှုနိုင်ပါ။",
    "loadSceneOverridePrompt": "လက်ရှိရေးဆွဲထားသမျှအား ပြင်ပမှတင်သွင်းသောပုံနှင့်အစားထိုးပါမည်။ ဆက်လက်ဆောင်ရွက်လိုပါသလား။",
    "collabStopOverridePrompt": "",
    "imageDoesNotContainScene": "",
    "cannotRestoreFromImage": "ဤပုံဖြင့်မြင်ကွင်းပြန်လည်မရယူနိုင်ပါ။",
    "invalidSceneUrl": "",
    "invalidEncryptionKey": "",
    "collabOfflineWarning": "",
    "localStorageQuotaExceeded": ""
  },
  "errors": {
    "unsupportedFileType": "",
    "imageInsertError": "",
    "fileTooBig": "",
    "svgImageInsertError": "",
    "failedToFetchImage": "",
    "cannotResolveCollabServer": "",
    "collabSaveFailed": "",
    "collabSaveFailed_sizeExceeded": "",
    "imageToolNotSupported": "",
    "brave_measure_text_error": {
      "line1": "",
      "line2": "",
      "line3": "",
      "line4": ""
    },
    "asyncPasteFailedOnRead": "",
    "asyncPasteFailedOnParse": "",
    "copyToSystemClipboardFailed": ""
  },
  "toolBar": {
    "selection": "ရွေးချယ်",
    "lasso": "",
    "image": "",
    "rectangle": "စတုဂံ",
    "diamond": "စိန်",
    "ellipse": "အဝိုင်း",
    "arrow": "မြှား",
    "line": "မျဉ်း",
    "freedraw": "",
    "text": "စာသား",
    "lock": "ရွေးချယ်ထားသောကိရိယာကိုသာဆက်သုံး",
    "penMode": "",
    "link": "",
    "eraser": "",
    "frame": "",
    "embeddable": "",
    "laser": "",
    "autoshape": "",
    "bucketfill": "",
    "hand": "",
    "extraTools": "",
    "convertElementType": ""
  },
  "bucketfill": {
    "noRegion": "",
    "tooComplex": ""
  },
  "element": {
    "rectangle": "",
    "diamond": "",
    "ellipse": "",
    "arrow": "",
    "line": "",
    "freedraw": "",
    "text": "",
    "image": "",
    "group": "",
    "frame": "",
    "embeddable": "",
    "selection": "",
    "iframe": ""
  },
  "headings": {
    "canvasActions": "ကားချပ်လုပ်ဆောင်ချက်",
    "selectedShapeActions": "ပုံသဏ္ဌာန်လုပ်ဆောင်ချက်",
    "shapes": "ပုံသဏ္ဌာန်များ"
  },
  "hints": {
    "dismissSearch": "",
    "canvasPanning": "",
    "linearElement": "အမှတ်များချမှတ်ရေးဆွဲရန်ကလစ်နှိပ်ပါ၊ မျဉ်းတစ်ကြောင်းတည်းအတွက် တရွတ်ဆွဲပါ။",
    "arrowTool": "",
    "arrowBindModifiers": "",
    "freeDraw": "ကလစ်နှိပ်၍ တရွတ်ဆွဲပါ၊ ပြီးလျှင်လွှတ်ပါ။",
    "text": "မှတ်ချက်။ ။မည်သည့်ကိရိယာရွေးထားသည်ဖြစ်စေ ကလစ်နှစ်ချက်နှိပ်၍စာသားထည့်နိုင်သည်",
    "embeddable": "",
    "autoshape": "",
    "text_selected": "",
    "text_editing": "",
    "linearElementMulti": "",
    "lockAngle": "",
    "resize": "",
    "resizeImage": "",
    "rotate": "",
    "toggleArrowhead": "",
    "lineEditor_info": "",
    "lineEditor_line_info": "",
    "lineEditor_pointSelected": "",
    "lineEditor_nothingSelected": "",
    "bindTextToElement": "",
    "createFlowchart": "",
    "deepBoxSelect": "",
    "eraserRevert": "",
    "firefox_clipboard_write": "",
    "disableSnapping": "",
    "enterCropEditor": "",
    "leaveCropEditor": ""
  },
  "canvasError": {
    "cannotShowPreview": "နမူနာမပြသနိုင်ပါ",
    "canvasTooBig": "ကားချပ်အလွန်ကြီးကောင်းကြီးနေနိုင်သည်။",
    "canvasTooBigTip": "မှတ်ချက်။ ။ဝေးကွာနေသော ပုံများ၊ စာများအား ပိုမိုနီးကပ်အောင်ရွှေ့ကြည့်ပါ။"
  },
  "errorSplash": {
    "headingMain": "ချို့ယွင်းမှုဖြစ်ပေါ်ခဲ့သဖြင့် ထပ်မံကြိုးစားကြည့်ရန် <button>စာမျက်နှာအား အသစ်ပြန်လည်ရယူပါ။</button>",
    "clearCanvasMessage": "အသစ်ပြန်လည်မရယူနိုင်ပါက ထပ်မံကြိုးစားကြည့်ရန်<button>ကားချပ်အား ရှင်းလင်းပါ။</button>",
    "clearCanvasCaveat": " ရေးဆွဲထားသည်များ ဆုံးရှုံးနိုင်သည် ",
    "trackedToSentry": "ချို့ယွင်းမှုသတ်မှတ်ချက် {{eventId}} အားစနစ်အတွင်းခြေရာကောက်ပြီးပါပြီ။",
    "openIssueMessage": "ချို့ယွင်းမှုမှတ်တမ်းတွင် အရေးကြီးအချက်အလက်များပါဝင်မှုမရှိစေရန်အထူးသတိပြုပါသည်။ မပါဝင်ပါက ဆက်လက်ဆောင်ရွက်ရန် <button>ချို့ယွင်းမှုအားခြေရာကောက်ပါ။</button> အောက်ပါအချက်အလက်များအား Github တွင် Issue အနေဖြင့်ဖြည့်သွင်းဖော်ပြပေးပါ။",
    "sceneContent": "မြင်ကွင်းပါအချက်အလက်။ ။"
  },
  "shareDialog": {
    "or": ""
  },
  "roomDialog": {
    "desc_intro": "",
    "desc_privacy": "",
    "button_startSession": "ပူးပေါင်းမှုစတင်",
    "button_stopSession": "ပူးပေါင်းမှုအဆုံးသတ်",
    "desc_inProgressIntro": "တိုက်ရိုက်ပူးပေါင်းရေးဆွဲမှုများပြုလုပ်နေပါသည်။",
    "desc_shareLink": "ဤလင့်ခ်အား ပူးပေါင်းရေးဆွဲလိုသူများထံပေးပို့ပါ။ ။ ",
    "desc_exitSession": "ပူးပေါင်းမှုရပ်တန့်ပါက အဖွဲ့အတွင်းမှထွက်ခွာသွားမည်ဖြစ်သော်လည်း မိမိမြင်ကွင်းတွင်ဆက်လက်ရေးဆွဲနိုင်ပါမည်။ အဖွဲ့အတွင်းကျန်ရှိနေခဲ့သောအခြားပါဝင်သူများသည်လည်း ဆက်လက်ပူးပေါင်းရေးဆွဲနေနိုင်ပါလိမ့်မည်။",
    "shareTitle": ""
  },
  "errorDialog": {
    "title": "ချို့ယွင်းချက်"
  },
  "progressDialog": {
    "title": "",
    "defaultMessage": ""
  },
  "exportDialog": {
    "disk_title": "",
    "disk_details": "",
    "disk_button": "",
    "link_title": "",
    "link_details": "",
    "link_button": "",
    "excalidrawplus_description": "",
    "excalidrawplus_button": "",
    "excalidrawplus_exportError": ""
  },
  "helpDialog": {
    "blog": "",
    "click": "",
    "deepSelect": "",
    "deepBoxSelect": "",
    "createFlowchart": "",
    "navigateFlowchart": "",
    "curvedArrow": "",
    "curvedLine": "",
    "documentation": "",
    "doubleClick": "",
    "drag": "",
    "editor": "",
    "editLineArrowPoints": "",
    "editText": "",
    "github": "",
    "howto": "",
    "or": "",
    "preventBinding": "",
    "tools": "",
    "shortcuts": "",
    "textFinish": "",
    "textNewLine": "",
    "title": "",
    "view": "",
    "zoomToFit": "",
    "zoomToSelection": "",
    "toggleElementLock": "",
    "movePageUpDown": "",
    "movePageLeftRight": "",
    "cropStart": "",
    "cropFinish": ""
  },
  "clearCanvasDialog": {
    "title": ""
  },
  "imageExportDialog": {
    "header": "",
    "label": {
      "withBackground": "",
      "onlySelected": "",
      "darkMode": "",
      "embedScene": "",
      "scale": "",
      "padding": ""
    },
    "tooltip": {
      "embedScene": ""
    },
    "title": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    },
    "button": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    }
  },
  "encrypted": {
    "tooltip": "ရေးဆွဲထားသောပုံများအား နှစ်ဘက်စွန်းတိုင်လျှို့ဝှက်ထားသဖြင့် Excalidraw ၏ဆာဗာများပင်လျှင်မြင်တွေ့ရမည်မဟုတ်ပါ။",
    "link": ""
  },
  "stats": {
    "angle": "ထောင့်",
    "shapes": "",
    "height": "အမြင့်",
    "scene": "မြင်ကွင်း",
    "selected": "ရွေးချယ်သည်",
    "storage": "သိုလှောင်ခန်း",
    "fullTitle": "",
    "title": "",
    "generalStats": "",
    "elementProperties": "",
    "total": "စုစုပေါင်း",
    "version": "",
    "versionCopy": "",
    "versionNotAvailable": "",
    "width": "အကျယ်"
  },
  "toast": {
    "copyStyles": "",
    "copyToClipboard": "",
    "copyToClipboardAsPng": "",
    "copyToClipboardAsSvg": "",
    "fileSaved": "",
    "fileSavedToFilename": "",
    "canvas": "",
    "selection": "",
    "pasteAsSingleElement": "",
    "unableToEmbed": "",
    "unrecognizedLinkFormat": "",
    "elementLinkCopied": ""
  },
  "colors": {
    "transparent": "",
    "black": "",
    "white": "",
    "red": "",
    "pink": "",
    "grape": "",
    "violet": "",
    "gray": "",
    "blue": "",
    "cyan": "",
    "teal": "",
    "green": "",
    "yellow": "",
    "orange": "",
    "bronze": ""
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_line2": "",
      "center_heading_line3": "",
      "center_heading_plus": "",
      "menuHint": ""
    },
    "defaults": {
      "menuHint": "",
      "center_heading": "",
      "toolbarHint": "",
      "helpHint": ""
    }
  },
  "colorPicker": {
    "color": "",
    "mostUsedCustomColors": "",
    "colors": "",
    "shades": "",
    "hexCode": "",
    "noShades": "",
    "invalidColor": "",
    "invalidHexLength": "",
    "topPicksTip": "",
    "resetTopPicks": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "",
        "button": "",
        "description": ""
      },
      "saveToDisk": {
        "title": "",
        "button": "",
        "description": ""
      },
      "excalidrawPlus": {
        "title": "",
        "button": "",
        "description": ""
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "",
        "button": "",
        "description": ""
      },
      "shareableLink": {
        "title": "",
        "button": "",
        "description": ""
      }
    }
  },
  "quickSearch": {
    "placeholder": ""
  },
  "fontList": {
    "badge": {
      "old": ""
    },
    "sceneFonts": "",
    "availableFonts": "",
    "empty": ""
  },
  "userList": {
    "empty": "",
    "hint": {
      "text": "",
      "followStatus": "",
      "inCall": "",
      "micMuted": "",
      "isSpeaking": ""
    }
  },
  "keys": {
    "ctrl": "",
    "option": "",
    "cmd": "",
    "alt": "",
    "escape": "",
    "enter": "",
    "shift": "",
    "spacebar": "",
    "delete": "",
    "mmb": ""
  }
}
